import type { EnvironmentVariable } from '@sb/remote-control/types';
import { convertGlobalVariableResponse } from '@sb/remote-control/util/convertGlobalVariableResponse';

import { getGlobalVariablesService } from './utils/getGlobalVariablesService';

export async function createGlobalVariable(
  globalVariable: EnvironmentVariable,
) {
  const response = await getGlobalVariablesService().create({
    globalVariableItem: {
      id: globalVariable.id,
      name: globalVariable.name,
      initialValue: globalVariable.initialValue,
      isGlobal: globalVariable.isGlobal || true, // Default to true
      persistent: globalVariable.persistent ?? false,
    },
  });

  return convertGlobalVariableResponse(response);
}
